/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bell': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4.94 14.222a3.522 3.522 0 006.12 0H4.94zM16 13.333H0v-2.418l.61-.2a3.012 3.012 0 002.06-2.857V5.333a5.33 5.33 0 1110.66 0v2.523a3.012 3.012 0 002.06 2.857l.61.2v2.418zM2.7 11.555h10.6a4.79 4.79 0 01-1.74-3.7V5.333a3.56 3.56 0 00-7.12 0v2.523a4.79 4.79 0 01-1.74 3.7z" _fill="#15161a" fill-rule="evenodd"/>'
  }
})
